import React from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios'
import SmartDataTable from 'react-smart-data-table'
import { Button, Modal } from 'semantic-ui-react';
import Spinner from './Spinner';
import { CSVLink } from 'react-csv';

const sematicUI = {
  segment: 'ui basic segment',
  message: 'ui message',
  input: 'ui icon input',
  searchIcon: 'search icon',
  rowsIcon: 'numbered list icon',
  table: 'ui compact selectable table',
  select: 'ui dropdown',
  refresh: 'ui labeled primary icon button',
  refreshIcon: 'sync alternate icon',
  change: 'ui labeled secondary icon button',
  changeIcon: 'exchange icon',
  checkbox: 'ui toggle checkbox',
  loader: 'ui active text loader',
  deleteIcon: 'trash red icon',
}

class OrderDataTable extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      useApi: true,
      apiData: this.props.data,
      apiIdx: -1,
      numResults: this.props.data.length,
      data: this.props.data,
      headers: this.props.headers,
      filterValue: '',
      perPage: 10,
      apiURL: this.props.apiURL,
      totalAmount: 0,
      totalFulfilled: 0,
      totalLiability: 0,
      allData: [],
      showAllModal: false,
    }

    this.setApiData = this.setApiData.bind(this)
    this.changeData = this.changeData.bind(this)
    this.handleOnChange = this.handleOnChange.bind(this)
    this.handleOnPerPage = this.handleOnPerPage.bind(this)
  }

  downloadAllData = (id) => {
    this.setState({ showAllModal: true })
    setTimeout(() => {
      axios
        .get('/api/order/downloadallorders')
        .then(res => {
          if (res.data.length > 0) {
            this.setState({ allData: res.data });
          }
        })
        .then(res => {
          let btn = this.refs.all;
          btn.link.click();
          this.setState({ allData: [] });
        })
        .catch(err => console.log(err))
    }, 100)
  }

  componentDidMount() {

    //this.setApiData()
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ data: nextProps.data, numResults: nextProps.data.length })

  }

  setApiData() {

    axios.get(this.state.apiURL)
      .then((response) => {
        console.log('response', response.data)
        this.setState({
          data: response.data,
          numResults: response.data.length
        })
      })
      .catch((error) => {
        // console.log(error);
      });
  }





  handleOnChange({ target: { name, value } }) {
    this.setState({ [name]: value }, () => {
      if (name === 'numResults') this.setNewData()
    })
  }

  handleOnPerPage({ target: { name, value } }) {
    this.setState({ [name]: parseInt(value, 10) })
  }

  changeData() {
    const { useApi } = this.state
    this.setState({
      useApi: !useApi,
      filterValue: '',
      perPage: 0,
    })
  }
  doneDownloadingAll = () => {
    this.setState({ showAllModal: false })
  }
  render() {
    const {
      headers, data, filterValue, perPage, numResults
    } = this.state
    const divider = <span style={{ display: 'inline-block', margin: '10px' }} />
    const today = new Date();
    const month = today.getMonth() + 1
    const filename = "All_Orders_" + today.getDate() + month + today.getFullYear() + ".csv"
    let dataToShow = '';
    let displayModal;
    if (this.state.showAllModal) {
      displayModal = (
        <Modal dimmer={true} open={true} closeOnDimmerClick={false} onClose={this.close}>
          <Modal.Header>Downloading Entire Database</Modal.Header>
          <Modal.Content>
            <Modal.Description>
              Your download will appear in your browser downloads
            <Spinner />
            </Modal.Description>
          </Modal.Content>
        </Modal>
      )
    } else {
      displayModal = null
    }

    !this.state.data ? dataToShow = (<Spinner />) : dataToShow = (<>
      <div className={sematicUI.segment}>
        <div className={sematicUI.input}>
          <input
            type='text'
            name='filterValue'
            value={filterValue}
            placeholder='Filter results...'
            onChange={this.handleOnChange}
          />
          <i className={sematicUI.searchIcon} />
        </div>
        {divider}
        <select
          name='perPage'
          value={perPage}
          className={sematicUI.select}
          onChange={this.handleOnPerPage}
        >
          <option value='10'>
            10
            </option>
          <option value='25'>
            25
            </option>
          <option value='50'>
            50
            </option>
          <option value='100'>
            100
            </option>
        </select>
        {divider}
        <Button type="button" color="blue" onClick={() => { this.downloadAllData() }}>
          Download All Orders
          </Button>
        <CSVLink
          ref="all"
          style={{ display: "none" }}
          filename={filename}
          asyncOnClick={true}
          data={this.state.allData}
          onClick={(event, done) => {
            done(this.doneDownloadingAll())
          }}
        />
      </div>
      <div className={sematicUI.message}>
        Total Results: {numResults}
      </div>
      <SmartDataTable
        data={data}
        dataKey=''
        headers={headers}
        name='test-table'
        className={sematicUI.table}
        filterValue={filterValue}
        perPage={perPage}
        sortable
        withLinks
        withHeader
        loader={(
          <div className={sematicUI.loader}>
            Loading...
            </div>
        )}

        emptyTable={(
          <Spinner />
        )}
      />
    </>
    )
    return (
      <>
        {dataToShow}
      </>
    )
  }
}

export default OrderDataTable;